module.exports = require("@splunk/dashboard-visualizations/common/EncodingDoc");